import * as types from './constants';

const showFlashMessage = (message, type = 'SUCCESS') => ({
  type: types.SHOW_FLASH_MESSAGE,
  message,
  messageType: type
});

const hideFlashMessage = () => ({
  type: types.HIDE_FLASH_MESSAGE
});

// One message at a time: a new one restarts the clock, so an earlier message's timer can't hide it early.
let flashTimer = null;
// Errors stay long enough to read (and for an AI assistant checking the screen to see them).
const MIN_ERROR_MS = 8000;

export const flashMessage = (message, type = 'SUCCESS', delay = 3000) =>
  (dispatch) => {
    dispatch(showFlashMessage(message, type));
    if (flashTimer) clearTimeout(flashTimer);
    flashTimer = setTimeout(() => { flashTimer = null; dispatch(hideFlashMessage()); }, type === 'ERROR' ? Math.max(delay, MIN_ERROR_MS) : delay);
  };

/* =============================================================================
=    Login API
============================================================================= */
const receiveLogin = user => ({
  type: types.RECEIVE_LOGIN,
  user
});

const requestLogin = () => ({
  type: types.REQUEST_LOGIN
});

const receiveLoginError = (error, isCredentialError = false) => ({
  type: types.RECEIVE_LOGIN_ERROR,
  error,
  isCredentialError
});

export const resetLoginError = () => ({
  type: types.RESET_LOGIN_ERROR
});

export const fetchLogin = (username, password) => async (dispatch) => {
  dispatch(requestLogin());
  const options = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ username, password })
  };
  const response = await fetch('/login', options);

  if (response.status === types.UNAUTHORIZED) {
    return dispatch(receiveLoginError(types.INVALID_CREDENTIALS_ERROR, true));
  }

  let json;

  try {
    json = await response.json();

    if (json.error) {
      return dispatch(receiveLoginError(json.error));
    }
  } catch (error) {
    console.error('fetchLogin error, failed to parse json.', error);
    return dispatch(receiveLoginError('Server error.'));
  }

  return dispatch(receiveLogin(json));
};

/* =============================================================================
=    Logout
============================================================================= */
const logoutSession = () => ({
  type: types.LOGOUT_SESSION
});

export const fetchLogout = () => async dispatch =>
  fetch('/logout', {
    credentials: 'same-origin'
  })
    .then(dispatch(logoutSession()))
    .then(res => window.location.replace(res.url))
    .catch(err => console.log(err));
